import { ProductSharedSettings } from "../models/product.shared";
import { DocumentData } from "@angular/fire/firestore";
import {
  BasicQuestion,
  SelectManyQuestion,
  SelectManyWithLimitQuestion,
  SelectOneQuestion,
  ShortAnswerQuestion
} from "../models";
import { ProductType, QuestionType } from "../enums";

export class ProductSharedSettingsBuilder {
  public isActive: boolean;
  public name: string;
  public type: ProductType;
  public description: string;
  public instructions: string;
  public warning: string;
  public questions: BasicQuestion[];
  public serviceFee?: number;
  public tips?: number[];

  constructor() {
    this.questions = [];
  }

  edit(shared: ProductSharedSettings) {
    this.isActive = shared.isActive;
    this.name = shared.name;
    this.type = shared.type;
    this.description = shared.description;
    this.instructions = shared.instructions;
    this.warning = shared.warning;
    this.questions = shared.questions;
    this.serviceFee = shared.serviceFee;
    this.tips = shared.tips;
  }

  load(data: DocumentData) {
    this.isActive = data.isActive;
    this.name = data.name;
    this.type = data.type;
    this.description = data.description;
    this.instructions = data.instructions;
    this.warning = data.warning;
    this.questions = this.map(data.questions as any[]);
    this.serviceFee = data.serviceFee / 100;
    this.tips = data.tips ? data.tips.map((tip: number) => tip / 100) : null;
  }

  map(questions: any[]) {
    return questions.map(question => {
      switch (question.type as QuestionType) {
        case QuestionType.SelectMany:
          return new SelectManyQuestion(question.question, question.options);
        case QuestionType.SelectManyWithLimit:
          return new SelectManyWithLimitQuestion(
            question.question,
            question.options,
            question.limit
          );
        case QuestionType.SelectOne:
          return new SelectOneQuestion(question.question, question.options);
        default:
          return new ShortAnswerQuestion(question.question);
      }
    });
  }
}
